export const parseDealCubeHistoryByLevel = <THistoryDetail, TItem, TKey extends string | number>(
  details: THistoryDetail[],
  getId: (detail: THistoryDetail) => string | null | undefined,
  getItems: (detail: THistoryDetail) => TItem[] | undefined,
  keyExtractor: (item: TItem) => TKey
): Map<string, Map<TKey, TItem>> => {
  const result = new Map<string, Map<TKey, TItem>>()

  details.forEach((detail) => {
    const id = getId(detail)
    if (!id) return

    if (!result.has(id)) {
      result.set(id, new Map<TKey, TItem>())
    }

    const targetMap = result.get(id)!
    getItems(detail)?.forEach((item) => {
      targetMap.set(keyExtractor(item), item)
    })
  })

  return result
}
